import { Layout, FloatButton } from 'antd';
import { Outlet } from 'react-router-dom';
import { UpOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

import LayoutContainer from '@layouts/Container';
import PageHeader from '@modules/common/PageHeader';
import PageSider from '@modules/common/PageSider';

import Cookies from "js-cookie";


const { Content } = Layout;

export default function LayoutDefault() {
  const [showSide, setShowSide] = useState(true);

  // useEffect(() => {
  //   const isInIframe = window.top !== window.self; 
  //   const url = new URL(window.location.href);

  //   if (isInIframe) {
  //     if (!url.searchParams.has("showSide")) {
  //       url.searchParams.set("showSide", "false");
  //       window.location.replace(url.toString());
  //     }
  //   }

  //   if (url.searchParams.get("showSide") === "false") {
  //     setShowSide(false);
  //   }
  // }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const isInIframe = window.top !== window.self;
    const isNotSideShow = Cookies.get("iframeNotShowSidebar") || url.searchParams.get("showSide") || isInIframe;

    if (isNotSideShow) {
      setShowSide(false);
    };
  }, [])

  function sendHeight() {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ height }, '*');
  }

  window.addEventListener('load', sendHeight);
  window.addEventListener('resize', sendHeight);

  return (
    <Layout hasSider>
      {showSide && <PageSider />}
      <LayoutContainer>
        {showSide && <PageHeader />}
        <Content>
          <Outlet />
        </Content>
      </LayoutContainer>
      <FloatButton.BackTop>
        <div className="back-top">
          <UpOutlined />
        </div>
      </FloatButton.BackTop>
    </Layout>
  );
}
